export const EXCMRELATIONUSERDATA_CREATE_RESET = 'EXCMRELATIONUSERDATA_CREATE_RESET'
export const EXCMRELATIONUSERDATA_CREATE_SET_CREATED = 'EXCMRELATIONUSERDATA_CREATE_SET_CREATED'
export const EXCMRELATIONUSERDATA_CREATE_SET_ERROR = 'EXCMRELATIONUSERDATA_CREATE_SET_ERROR'
export const EXCMRELATIONUSERDATA_CREATE_SET_VIOLATIONS = 'EXCMRELATIONUSERDATA_CREATE_SET_VIOLATIONS'
export const EXCMRELATIONUSERDATA_CREATE_TOGGLE_LOADING = 'EXCMRELATIONUSERDATA_CREATE_TOGGLE_LOADING'
